//Constants

import { call, put, putResolve } from 'redux-saga/effects'
import Api from '../../services/Api';
import { putRequest, ApiUrl } from '../../services/Network';
import { API_FAILURE, API_FETCHING, API_INITIAL, API_SUCCESS, isSuccessStatusCode, ReduxApiStatus } from "../../common/constants/ApiConstants"
import {
    getUserAttributeAPI,
    requestOtpOrLoginAPI,
    logoutUserAPI,
    advanceSearchLogout,
    getFeatureFlagsAPI,
    getQAFeatureFlagsAPI,
    getTokenLoginAPI,
    returnToSearchAPI,
    refreshUserRedisCacheAPI,
    getUserPreferencesAPI,
    saveUserPreferencesAPI,
    getPreferenceValuesAPI,
    getPdfTronAPI,
    resolveDomainAPI,
    getSamlSigninUrlAPI,
} from "../dataEntryDetails/test/DataEntry.APIs";
import { replace } from '../../redux/navigation/navigationDucks';
import { LandingPageActionConstants, showReadOnlyTransactionSaga } from '../landingPage/LandingPageDucks';
import Preferences, { tryLoadPrefs } from '../../models/preferences';
import { FeatureFlagsType } from '../../common/customTypes/FeatureFlagsType';
import { ProceedLoginAction } from '../../common/customTypes/ProceedLoginActionType';
import { get } from 'http';

export const LoginConstants = {
    getOtpOrLoginRequest: "getOtpOrLoginRequest/LoginPageConstants",
    getOtpOrLoginSuccess: "getOtpOrLoginSuccess/LoginPageConstants",
    getOtpOrLoginFailure: "getOtpOrLoginFailure/LoginPageConstants",
    getUserAttributesRequest: "getUserAttributesRequest/LoginPageConstants",
    getUserAttributesSuccess: "getUserAttributesSuccess/LoginPageConstants",
    getUserAttributesFailure: "getUserAttributesFailure/LoginPageConstants",
    getResendOtpForLoginRequest: "getResendOtpForLoginRequest/LoginPageConstants",
    logoutUserRequest: "logoutUserRequest/LoginPageConstants",
    logoutUserSuccess: "logoutUseSuccess/LoginPageConstants",
    logoutUserFailure: "logoutUseFailure/LoginPageConstants",
    resetReduxState: "RESET_STATE",
    putHeartbeatRequest: "putHeartbeatRequest",
    putHeartbeatFailure: "putHeartbeatFailure",
    getFeatureFlagsRequest: "getFeatureFlagsRequest/LoginPageConstants",
    getFeatureFlagsSuccess: "getFeatureFlagsSuccess/LoginPageConstants",
    getFeatureFlagsFailure: "getFeatureFlagsFailure/LoginPageConstants",
    getQAFeatureFlagsRequest: "getQAFeatureFlagsRequest/LoginPageConstants",
    getQAFeatureFlagsSuccess: "getQAFeatureFlagsSuccess/LoginPageConstants",
    getQAFeatureFlagsFailure: "getQAFeatureFlagsFailure/LoginPageConstants",
    getPdfTronRequest: "getPdfTronRequest",
    getPdfTronSuccess: "getPdfTronSuccess",
    getPdfTronFailure: "getPdfTronFailure",
    getTokenLoginRequest: "getTokenLoginRequest/LoginPageConstants",
    getTokenLoginSuccess: "getTokenLoginSuccess/LoginPageConstants",
    getTokenLoginFailure: "getTokenLoginFailure/LoginPageConstants",
    returnToSearchRequest: "returnToSearchRequest",
    returnToSearchFailure: "returnToSearchFailure",
    clearPreviousSearch: "clearPreviousSearch",
    refreshUserRedisCacheRequest: "refreshUserRedisCacheRequest/LoginPageConstants",
    refreshUserRedisCacheSuccess: "refreshUserRedisCacheSuccess/LoginPageConstants",
    refreshUserRedisCacheFailure: "refreshUserRedisCacheFailure/LoginPageConstants",
    getUserPreferencesRequest: "getUserPreferencesRequest",
    getUserPreferencesSuccess: "getUserPreferencesSuccess",
    getUserPreferencesFailure: "getUserPreferencesFailure",
    saveUserPreferencesRequest: "saveUserPreferencesRequest",
    saveUserPreferencesSuccess: "saveUserPreferencesSuccess",
    saveUserPreferencesFailure: "saveUserPreferencesFailure",
    setUserPreferences: "setUserPreferences",
    getPreferenceValuesRequest: "getPreferenceValuesRequest",
    getPreferenceValuesSuccess: "getPreferenceValuesSuccess",
    getPreferenceValuesFailure: "getPreferenceValuesFailure",
    proceedLoginRequest: "proceedLoginRequest",
    proceedLoginSuccess: "proceedLoginSuccess",
    proceedLoginFailure: "proceedLoginFailure",
    getSamlSigninRequest: "getSamlSigninRequest",
    getSamlSigninSuccess: "getSamlSigninSuccess",
    getSamlSigninFailure: "getSamlSigninFailure",
}
// create reducers here
const userid = sessionStorage.getItem('userID');
const userAttributes = sessionStorage.getItem('userAttributes');
const featureFlags = sessionStorage.getItem('featureFlags');
const pdfTronKey = sessionStorage.getItem("pdfTronKey");

export interface FeatureFlags {
    readonly [key: string]: true | undefined;
}

export interface LandingPageState {
    readonly getOtpAPIStatus: ReduxApiStatus,
    readonly loginAPIStatus: ReduxApiStatus,
    readonly errorMessage?: string,
    readonly getAttributesAPIStatus: ReduxApiStatus,
    readonly userAttributes: any,
    readonly userID?: number,
    readonly errorDescription: string,
    readonly getFeatureFlagsAPIStatus: ReduxApiStatus,
    readonly getQAFeatureFlagsAPIStatus: ReduxApiStatus,
    readonly getPdfTronAPIStatus: ReduxApiStatus,
    readonly featureFlags: FeatureFlags,
    readonly getTokenLoginAPIStatus: ReduxApiStatus,
    readonly previousSearchParameters?: string | null,
    readonly previousSearchPage?: number | null,
    readonly returnToSearchAPIStatus: ReduxApiStatus;
    readonly preferences?: Preferences,
    readonly getPreferencesStatus: ReduxApiStatus,
    readonly savePreferencesStatus: ReduxApiStatus,
    readonly preferenceValues?: readonly any [],
    readonly getPreferenceValuesStatus: ReduxApiStatus,
    readonly pdfTronKey: string,
    readonly QAFeatureFlags?: FeatureFlagsType;
    readonly transactionId?: string;
    readonly ssoEnabled: boolean;
    readonly accountActive: boolean;
    readonly getSsoEnabledStatus: ReduxApiStatus;
}

const defaultState: LandingPageState = {
    getOtpAPIStatus: API_INITIAL,
    loginAPIStatus: API_INITIAL,
    getAttributesAPIStatus: API_INITIAL,
    userAttributes: userAttributes ? JSON.parse(userAttributes) : undefined,
    userID: userid ? JSON.parse(userid) : undefined,
    errorDescription: "",
    getFeatureFlagsAPIStatus: API_INITIAL,
    getQAFeatureFlagsAPIStatus: API_INITIAL,
    getPdfTronAPIStatus: API_INITIAL,
    featureFlags: featureFlags ? JSON.parse(featureFlags) : {},
    getTokenLoginAPIStatus: API_INITIAL,
    returnToSearchAPIStatus: API_INITIAL,
    preferences: tryLoadPrefs(),
    getPreferencesStatus: API_INITIAL,
    savePreferencesStatus: API_INITIAL,
    getPreferenceValuesStatus: API_INITIAL,
    pdfTronKey: pdfTronKey ?? "",
    ssoEnabled: false,
    accountActive: true,
    getSsoEnabledStatus: API_INITIAL
}

export const loginState = (state: LandingPageState = defaultState, action: any): LandingPageState => {
    const key = action.data && action.data.otp && action.data.otp.length ? "loginAPIStatus" : "getOtpAPIStatus"
    switch (action.type) {
        case LoginConstants.getOtpOrLoginRequest:
            return {
                ...state,
                [key]: API_FETCHING
            }
        case LoginConstants.getOtpOrLoginSuccess:
            global.userID = action.data.userID;
            sessionStorage.setItem("userID", JSON.stringify(action.data.userID))

            return {
                ...state,
                [key]: action.data.status,
                userID: action.data.userID,
                errorDescription: action.data.errorDescription
            }
        case LoginConstants.getResendOtpForLoginRequest:
            return {
                ...state,
                [key]: API_SUCCESS,
            }
        case LoginConstants.getOtpOrLoginFailure:
            return {
                ...state,
                [key]: API_FAILURE,
                errorMessage: action.data
            }
        case LoginConstants.getUserAttributesRequest:
            return {
                ...state,
                getAttributesAPIStatus: API_FETCHING
            }
        case LoginConstants.getUserAttributesSuccess:
            sessionStorage.setItem("userAttributes", JSON.stringify(action.data))
            return {
                ...state,
                userAttributes: action.data,
                getAttributesAPIStatus: API_SUCCESS
            }
        case LoginConstants.getUserAttributesFailure:
            return {
                ...state,
                getAttributesAPIStatus: API_FAILURE
            }
        case LoginConstants.logoutUserRequest:
            return {
                ...state,
                getAttributesAPIStatus: API_FETCHING
            }
        case LoginConstants.logoutUserSuccess:
            sessionStorage.clear();
            sessionStorage.removeItem("userID");
            sessionStorage.removeItem("userAttributes");
            sessionStorage.removeItem("featureFlags");
            return {
                ...defaultState,
                getAttributesAPIStatus: API_SUCCESS
            }
        case LoginConstants.logoutUserFailure:
            return {
                ...state,
                getAttributesAPIStatus: API_FAILURE
            }
        case LoginConstants.putHeartbeatFailure:
            return {
                ...state,
                getAttributesAPIStatus: API_FAILURE
            }
        case LoginConstants.getFeatureFlagsRequest:
            return {
                ...state,
                getFeatureFlagsAPIStatus: API_FETCHING
            }
        case LoginConstants.getFeatureFlagsSuccess:
            sessionStorage.setItem("featureFlags", JSON.stringify(action.data))
            return {
                ...state,
                featureFlags: action.data,
                getFeatureFlagsAPIStatus: API_SUCCESS
            }
        case LoginConstants.getFeatureFlagsFailure:
            return {
                ...state,
                getFeatureFlagsAPIStatus: API_FAILURE
            }
        case LoginConstants.getQAFeatureFlagsRequest:
            return {
                ...state,
                getQAFeatureFlagsAPIStatus: API_FETCHING
            }
        case LoginConstants.getQAFeatureFlagsSuccess:
            sessionStorage.setItem("QAFeatureFlags", JSON.stringify(action.data))
            return {
                ...state,
                QAFeatureFlags: action.data,
                getQAFeatureFlagsAPIStatus: API_SUCCESS
            }
        case LoginConstants.getQAFeatureFlagsFailure:
            return {
                ...state,
                getQAFeatureFlagsAPIStatus: API_FAILURE
            }
        case LoginConstants.getPdfTronRequest:
            return {
                ...state,
                getPdfTronAPIStatus: API_FETCHING
            }
        case LoginConstants.getPdfTronSuccess:
            sessionStorage.setItem("pdfTronKey", action.data);
            return {
                ...state,
                pdfTronKey: action.data,
                getPdfTronAPIStatus: API_SUCCESS
            }
        case LoginConstants.getPdfTronFailure:
            return {
                ...state,
                getPdfTronAPIStatus: API_FAILURE
            }
        case LoginConstants.getTokenLoginRequest:
            return {
                ...state,
                getTokenLoginAPIStatus: API_FETCHING
            }
        case LoginConstants.getTokenLoginSuccess:
            global.userID = action.data.userId;
            sessionStorage.setItem("userID", JSON.stringify(action.data.userId))
            return {
                ...state,
                transactionId: action.data.transactionId,
                userID: action.data.userId,
                previousSearchParameters: action.data.previousSearchParameters,
                previousSearchPage: action.data.previousSearchPage,
                getTokenLoginAPIStatus: API_SUCCESS
            }
        case LoginConstants.getTokenLoginFailure:
            return {
                ...state,
                getTokenLoginAPIStatus: API_FAILURE
            }
        case LoginConstants.returnToSearchRequest:
            return {
                ...state,
                returnToSearchAPIStatus: API_FETCHING
            }
        case LoginConstants.returnToSearchFailure:
            return {
                ...state,
                returnToSearchAPIStatus: API_FAILURE
            }
        case LoginConstants.clearPreviousSearch:
            return {
                ...state,
                previousSearchParameters: null,
                previousSearchPage: null,
            }
        case LoginConstants.getUserPreferencesRequest:
            return {
                ...state,
                getPreferencesStatus: API_FETCHING
            }
        case LoginConstants.getUserPreferencesSuccess:
            const prefs = {
                showThumbnails: action.data.find(x => x.settingID == 1)?.settingValue.toLowerCase() == "true",
                zoomLevel: action.data.find(x => x.settingID == 2)?.settingValue,
                showBookmarks: action.data.find(x => x.settingID == 3)?.settingValue.toLowerCase() == "true",
            }
            localStorage.setItem("preferences", JSON.stringify(prefs));
            return {
                ...state,
                getPreferencesStatus: API_SUCCESS,
                preferences: prefs,
            }
        case LoginConstants.getUserPreferencesFailure:
            return {
                ...state,
                getPreferencesStatus: API_FAILURE
            }
        case LoginConstants.saveUserPreferencesRequest:
            return {
                ...state,
                savePreferencesStatus: API_FETCHING
            }
        case LoginConstants.saveUserPreferencesSuccess:
            return {
                ...state,
                savePreferencesStatus: API_SUCCESS,
            }
        case LoginConstants.saveUserPreferencesFailure:
            return {
                ...state,
                savePreferencesStatus: API_FAILURE
            }
        case LoginConstants.getPreferenceValuesRequest:
            return {
                ...state,
                getPreferencesStatus: API_FETCHING
            }
        case LoginConstants.getPreferenceValuesSuccess:
            return {
                ...state,
                getPreferencesStatus: API_SUCCESS,
                preferenceValues: action.data,
            }
        case LoginConstants.getPreferenceValuesFailure:
            return {
                ...state,
                getPreferencesStatus: API_FAILURE
            }
        case LoginConstants.setUserPreferences:
            localStorage.setItem("preferences", JSON.stringify(action.data));
            return {
                ...state,
                preferences: action.data,
            }
        case LoginConstants.proceedLoginRequest:
            return {
                ...state,
                getSsoEnabledStatus: API_FETCHING
            }
     case LoginConstants.proceedLoginSuccess:
            return {
                ...state,
                ssoEnabled: action.data.ssoEnabled,
                accountActive: action.data.accountActive,
                getSsoEnabledStatus: action.data.getSsoEnabledStatus
            }
        case LoginConstants.proceedLoginFailure:
            return {
                ...state,
                getSsoEnabledStatus: API_FAILURE
            }
        case LoginConstants.getSamlSigninRequest:
            return {
                ...state,
                getSsoEnabledStatus: API_FETCHING
            }
        case LoginConstants.getSamlSigninSuccess:
            global.userID = action.data.userID;
            sessionStorage.setItem("userID", JSON.stringify(action.data.userID))
            return {
                ...state,
                [key]: action.data.status,
                userID: action.data.userID
            }
        case LoginConstants.getSamlSigninFailure:
            return {
                ...state,
                [key]: API_FAILURE
            }
        default:
            return state
    }
}

// create action creators here

export function resetState() {
    return {
        type: LoginConstants.resetReduxState
    }
}

export function proceedLoginRequest(email: string, onComplete?: (status: number, error?: string) => void): ProceedLoginAction {
    return {
        type: LoginConstants.proceedLoginRequest,
        email,
        onComplete
    };
}

export function getOtpOrLoginRequest(userName: string, otp?: string, onAPISuccess?: Function) {
    return {
        type: LoginConstants.getOtpOrLoginRequest,
        userName,
        otp,
        onAPISuccess
    }
}

export function getTokenLoginRequest(token: string) {
    return {
        type: LoginConstants.getTokenLoginRequest,
        token,
    }
}

export function logoutUserRequest(action) {
    return {
        type: LoginConstants.logoutUserRequest,
        userId: action.userId,
        redirect: action.redirect
    }
}

export function getUserAttributesRequest() {
    return {
        type: LoginConstants.getUserAttributesRequest
    }
}

export const putHeartbeatRequest = () => {
    return {
        type: LoginConstants.putHeartbeatRequest,
        data: {}
    }
}

export function getFeatureFlagsRequest() {
    return {
        type: LoginConstants.getFeatureFlagsRequest
    }
}

export function getQAFeatureFlagsRequest() {
    return {
        type: LoginConstants.getQAFeatureFlagsRequest
    }
}

export function getPdfTronRequest() {
    return {
        type: LoginConstants.getPdfTronRequest
    }
}

export function returnToSearchRequest(organizationId?: number, requestBufferId?: number, parameters?: string, page?: number) {
    return {
        type: LoginConstants.returnToSearchRequest,
        data: {
            organizationId,
            requestBufferId,
            parameters,
            page,
        },
    }
}

export function refreshUserRedisCacheRequest() {
    return { type: LoginConstants.refreshUserRedisCacheRequest }
}

export function clearPreviousSearch() {
    return { type: LoginConstants.clearPreviousSearch };
}

export function setUserPreferences(preferences: Preferences) {
    return { type: LoginConstants.setUserPreferences, data: preferences }
}

export function savePreference(preferenceValueId: number) {
    return { type: LoginConstants.saveUserPreferencesRequest, data: preferenceValueId }
}

export function getPreferenceValues() {
    return { type: LoginConstants.getPreferenceValuesRequest }
}

// create sagas here

// GET OTP OR LOGIN

export function* proceedLoginSaga(action: ProceedLoginAction) {
    try {
        const response = yield call(resolveDomainAPI, action.email);

        const ssoEnabled = response.data.ssoEnabled;
        const testUsername = response.data.testUsername;
        yield put(
            { 
                type: LoginConstants.proceedLoginSuccess,
                data: {
                    ssoEnabled: ssoEnabled, testUsername: testUsername, accountActive: true, getSsoEnabledStatus: API_SUCCESS
                } 
            });

            var testUsernameExists;
            if(testUsername === null || testUsername === "")
            {
                testUsernameExists = false;
            } else testUsernameExists = true;
    

        if (!ssoEnabled || ( ssoEnabled && testUsernameExists && testUsername != action.email)) {
        yield put({
            type: LoginConstants.getOtpOrLoginRequest,
            userName: action.email,
            otp: "",
            onAPISuccess: action.onComplete
        });
        } else {
            const domain = action.email?.split('@')[1] ?? '';
            const returnUrl = `${window.location.origin}/home`;
            const signinUrl = `${ApiUrl()}${Api.getSamlSigninUrl}?domain=${encodeURIComponent(domain)}&returnUrl=${encodeURIComponent(returnUrl)}`;
            window.location.replace(signinUrl);  // Redirect to SAML Signin URL          
        }
    } catch (err) {
        yield put({
        type: LoginConstants.proceedLoginFailure,
        data: err
        });
    }
}


export function* getOtpOrLogin(action: any) {
    let requestObject = {
        userName: action.userName,
        otp: action.otp,
        resendOtp: action.resendOtp
    }
    try {
        const response = yield call(requestOtpOrLoginAPI, requestObject)
        if (isSuccessStatusCode(response.status)) {
            yield put({
                type: LoginConstants.getOtpOrLoginSuccess,
                data: {
                    ...response.data, userName: action.userName,
                    getOtpAPIStatus: response.status, status: API_SUCCESS, userID: response.data
                }
            });
            if (requestObject.otp !== "") {
                yield put({ type: LoginConstants.getUserPreferencesRequest });
            }
            action.onAPISuccess && action.onAPISuccess(response.status, "")
        }
    } catch (err) {
        if ((err as any).response?.status === 400) {
            action.onAPISuccess && action.onAPISuccess((err as any).response?.status, (err as any).response?.data[0]?.message)
        } else {
            action.onAPISuccess && action.onAPISuccess((err as any).response?.status, (err as any).response?.data)
        }
        yield put({
            type: LoginConstants.getOtpOrLoginFailure,
            data: err
        })
    }
}

export function* getTokenLogin(action: any) {
    let requestObject = {
        token: action.token
    }
    try {
        const response = yield call(getTokenLoginAPI, requestObject)
        if (isSuccessStatusCode(response.status)) {
            yield putResolve({
                type: LoginConstants.getTokenLoginSuccess,
                data: {
                    ...response.data,
                    userID: response.data.userId,
                    transactionId: response.data.transactionId,
                    getTokenLoginAPIStatus: response.status,
                    previousSearchParameters: response.data.parameters,
                    previousSearchPage: response.data.page,
                    status: API_SUCCESS,
                }
            })
            yield put({ type: LoginConstants.getUserPreferencesRequest });
            yield putResolve({ type: LoginConstants.getUserAttributesRequest });
            yield putResolve({ type: LandingPageActionConstants.getInitialsRequest });
            if (response.data.transactionId)
            {
                yield putResolve({ type: LandingPageActionConstants.onClickHealthOrganization, data: response.data.systemDetails });
                yield putResolve({ type: LandingPageActionConstants.updateSelectedFacilityDetails, data: response.data.facilityDetails });
                if (response.data.readOnly) {
                    yield put(replace("/home"));
                    yield showReadOnlyTransactionSaga({ data: response.data.transactionId });
                } else {
                    yield putResolve({ type: LandingPageActionConstants.getTransactionIdSuccess, data: response.data.transactionId });
                    yield put(replace("/data"))
                }
            } else {
                yield put(replace("/home"))
            }
            
        }
    } catch (err) {
        yield put({
            type: LoginConstants.getTokenLoginFailure,
            data: err
        });
        yield put(replace("/"));
    }
}

export function* returnToSearchSaga(action: any) {
    try {
        const response = yield call(returnToSearchAPI, action.data);
        if (isSuccessStatusCode(response.status)) {
            window.location.replace(response.data.url);
        }
    } catch (err) {
        if ((err as any).response?.status === 400) {
            action.onAPIResponse((err as any).response?.status, (err as any).response?.data[0]?.message)
        } else {
            action.onAPIResponse((err as any).response?.status, (err as any).response?.data)
        }
        yield put({
            type: LoginConstants.returnToSearchFailure,
            data: err
        })
    }
}

//takes in userID
export function* logoutUsers(action: any) {
    let requestObject = {
        userId: action.userId,
    }
    try {
        const response = yield call(logoutUserAPI, requestObject)
        const heartbeatID = parseInt(sessionStorage.getItem("heartbeatID") || "", 10);
        sessionStorage.clear();
        if (isSuccessStatusCode(response.status)) {
            try {
                yield call(advanceSearchLogout);
            } catch(error){
                console.error("Error logut advance search ", error)
            }
            action.redirect()
            yield put({
                type: LoginConstants.logoutUserSuccess,
                data: {
                    ...response.data,
                    getOtpAPIStatus: response.status, status: API_SUCCESS
                }
            })
        }
    } catch (err) {
        yield put({
            type: LoginConstants.logoutUserFailure,
            data: err
        })
    }
}


export async function callHeartbeatSaga(action: any) {
    return await putRequest(Api.putHeartbeat + "?userID=" + action.userId, {})
        .then(resp => {
            return resp;
        })
        .catch(err => {
            //put({ type: LoginConstants.putHeartbeatFailure, data: err.response });
            return { status: err.response.status }
        })
}


// GET USER ATTRIBUTES
export function* getUserAttributes() {
    try {
        const response = yield call(getUserAttributeAPI, {})
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: LoginConstants.getUserAttributesSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: LoginConstants.getUserAttributesFailure, data: err })
    }
}
/* Get Resend OTP */
export function getResendOtpForLoginRequest(userName: string, otp?: string) {
    return {
        type: LoginConstants.getResendOtpForLoginRequest,
        userName,
        otp
    }
}

export function* getFeatureFlags() {
    try {
        const response = yield call(getFeatureFlagsAPI, {})
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: LoginConstants.getFeatureFlagsSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: LoginConstants.getFeatureFlagsFailure, data: err })
    }
}

export function* getQAFeatureFlags() {
    try {
        const response = yield call(getQAFeatureFlagsAPI, {})
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: LoginConstants.getQAFeatureFlagsSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: LoginConstants.getQAFeatureFlagsFailure, data: err })
    }
}

export function* refreshUserRedisCacheSaga() {
    try {
        const response = yield call(refreshUserRedisCacheAPI)

        if (isSuccessStatusCode(response.status)) {
            yield put({
                type: LoginConstants.refreshUserRedisCacheSuccess,
                data: {
                    ...response.data,
                    getOtpAPIStatus: response.status, status: API_SUCCESS
                }
            })
        }
    } catch (err) {
        yield put({
            type: LoginConstants.refreshUserRedisCacheFailure,
            data: err
        })
    }
}

export function* getUserPreferences() {
    try {
        const response = yield call(getUserPreferencesAPI);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: LoginConstants.getUserPreferencesSuccess, data: response.data })
        } else {
            yield put({ type: LoginConstants.getUserPreferencesFailure })
        }
    } catch (err) {
        yield put({ type: LoginConstants.getUserPreferencesFailure, data: err })
    }
}

export function* saveUserPreferencesSaga(action: any) {
    try {
        const response = yield call(saveUserPreferencesAPI, action);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: LoginConstants.saveUserPreferencesSuccess })
        } else {
            yield put({ type: LoginConstants.saveUserPreferencesFailure })
        }
    } catch (err) {
        yield put({ type: LoginConstants.saveUserPreferencesFailure, data: err })
    }
}

export function* getPreferenceValuesSaga() {
    try {
        const response = yield call(getPreferenceValuesAPI);
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: LoginConstants.getPreferenceValuesSuccess, data: response.data })
        } else {
            yield put({ type: LoginConstants.getPreferenceValuesFailure })
        }
    } catch (err) {
        yield put({ type: LoginConstants.getPreferenceValuesFailure, data: err })
    }
}

export function* getPdfTronKey() {
    try {
        const response = yield call(getPdfTronAPI, {})
        if (isSuccessStatusCode(response.status)) {
            yield put({ type: LoginConstants.getPdfTronSuccess, data: response.data })
        }
    } catch (err) {
        yield put({ type: LoginConstants.getPdfTronFailure, data: err })
    }
}